const isDevelopment = process.env.NODE_ENV === 'development';

/**
 * Secure logging utility that prevents sensitive data exposure
 */
export const secureLog = {
  // Only log in development environment
  debug: (message, data = {}) => {
    if (isDevelopment) {
      const sanitizedData = sanitizeData(data);
      console.debug(message, sanitizedData);
    }
  },
  
  info: (message, data = {}) => {
    if (isDevelopment) {
      const sanitizedData = sanitizeData(data);
      console.info(message, sanitizedData);
    }
  },
  
  warn: (message, data = {}) => {
    // Warnings can be shown in production but with sanitized data
    const sanitizedData = sanitizeData(data);
    console.warn(message, sanitizedData);
  },
  
  error: (message, error, data = {}) => {
    // Errors should be logged but with sanitized data
    const sanitizedData = sanitizeData(data);
    console.error(message, error, sanitizedData);
  }
};

/**
 * Sanitizes data to remove sensitive information
 */
function sanitizeData(data) {
  if (!data) return {};
  
  // Create a deep copy to avoid modifying the original
  const sanitized = JSON.parse(JSON.stringify(data));
  
  // List of sensitive fields to redact
  const sensitiveFields = [
    'uuid', 'id', 'token', 'cardToken', 'apiKey', 'password', 
    'email', 'phone', 'address', 'geolocation'
  ];
  
  // Recursively sanitize objects
  function sanitizeObject(obj) {
    if (!obj || typeof obj !== 'object') return obj;
    
    Object.keys(obj).forEach(key => {
      // Check if the key is sensitive
      if (sensitiveFields.some(field => key.toLowerCase().includes(field.toLowerCase()))) {
        obj[key] = '[REDACTED]';
      } 
      // If it's a nested object or array, recursively sanitize
      else if (typeof obj[key] === 'object' && obj[key] !== null) {
        obj[key] = sanitizeObject(obj[key]);
      }
    });
    
    return obj;
  }
  
  return sanitizeObject(sanitized);
}

export default secureLog; 